"use strict";

var _WeakMap = require("@babel/runtime-corejs3/core-js-stable/weak-map");
var _Object$defineProperty = require("@babel/runtime-corejs3/core-js-stable/object/define-property");
var _Object$getOwnPropertyDescriptor = require("@babel/runtime-corejs3/core-js-stable/object/get-own-property-descriptor");
var _interopRequireDefault = require("@babel/runtime-corejs3/helpers/interopRequireDefault");
_Object$defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _fill = _interopRequireDefault(require("@babel/runtime-corejs3/core-js-stable/instance/fill"));
var _sort = _interopRequireDefault(require("@babel/runtime-corejs3/core-js-stable/instance/sort"));
var _map = _interopRequireDefault(require("@babel/runtime-corejs3/core-js-stable/instance/map"));
var _react = _interopRequireDefault(require("react"));
var T = _interopRequireWildcard(require("prop-types"));
var _classnames = _interopRequireDefault(require("classnames"));
var _recharts = require("recharts");
var _AutoIntl = _interopRequireDefault(require("./AutoIntl"));
var _AuComponent = _interopRequireDefault(require("./AuComponent"));
function _getRequireWildcardCache(e) { if ("function" != typeof _WeakMap) return null; var r = new _WeakMap(), t = new _WeakMap(); return (_getRequireWildcardCache = function (e) { return e ? t : r; })(e); }
function _interopRequireWildcard(e, r) { if (!r && e && e.__esModule) return e; if (null === e || "object" != typeof e && "function" != typeof e) return { default: e }; var t = _getRequireWildcardCache(r); if (t && t.has(e)) return t.get(e); var n = { __proto__: null }, a = _Object$defineProperty && _Object$getOwnPropertyDescriptor; for (var u in e) if ("default" !== u && Object.prototype.hasOwnProperty.call(e, u)) { var i = a ? _Object$getOwnPropertyDescriptor(e, u) : null; i && (i.get || i.set) ? _Object$defineProperty(n, u, i) : n[u] = e[u]; } return n.default = e, t && t.set(e, n), n; }
var styles = {
  "pie_center": "pie_chart-module__pie_center___eF_dm",
  "centered_title": "pie_chart-module__centered_title___x2rvt",
  "title_with_subtitle": "pie_chart-module__title_with_subtitle___MOxEB",
  "label_text": "pie_chart-module__label_text___imwch",
  "label": "pie_chart-module__label___eZOad",
  "container": "pie_chart-module__container___mFp_c",
  "tooltip": "pie_chart-module__tooltip___QsLnc",
  "tooltip_circle": "pie_chart-module__tooltip_circle___zsWh4",
  "tooltip_bold": "pie_chart-module__tooltip_bold___uF2pj",
  "tooltip_text": "pie_chart-module__tooltip_text___eDxG_",
  "tooltip_link": "pie_chart-module__tooltip_link___gCFSP",
  "sub_title": "pie_chart-module__sub_title___TGYIu",
  "empty": "pie_chart-module__empty___zgIwW"
};
const CustomTooltip = ({
  payload
}) => {
  if (payload && payload[0]) {
    const tooltip = /*#__PURE__*/_react.default.createElement("div", {
      className: styles.tooltip
    }, /*#__PURE__*/_react.default.createElement("div", {
      className: styles.tooltip_circle,
      style: {
        backgroundColor: (0, _fill.default)(payload[0].payload)
      }
    }), /*#__PURE__*/_react.default.createElement("div", {
      className: styles.tooltip_text
    }, payload[0].payload.name, ": ", payload[0].payload.value));
    return tooltip;
  }
  return null;
};
const pieLabel = props => {
  const {
    cx,
    cy,
    midAngle,
    innerRadius,
    outerRadius,
    payload
  } = props;
  // the positioning for this label is still buggy, using built in recharts label for now but keeping this code in case we want to improve it and use it in the future
  const RADIAN = Math.PI / 180;
  const thickness = outerRadius - innerRadius;
  const midRadius = innerRadius + thickness;
  const sin = Math.sin(-RADIAN * midAngle);
  const cos = Math.cos(-RADIAN * midAngle);
  const mx = cx + (outerRadius + 10) * cos;
  const my = cy + (outerRadius + 10) * sin;
  const ex = mx + (cos >= 0 ? 1 : -1) * 70 * Math.pow(Math.E, -3.5 * Math.abs(cos)); // max second path length longer if on top or bottom
  const ey = my;
  const transform = cos >= 0 ? 'translate(-10, 0)' : 'translate(10, 0)';
  const psx = cx + (midRadius - 10) * cos;
  const psy = cy + (midRadius - 10) * sin;
  return /*#__PURE__*/_react.default.createElement("g", null, /*#__PURE__*/_react.default.createElement("path", {
    d: `M${psx},${psy}L${mx},${my}L${ex},${ey}`,
    className: styles.label
  }), /*#__PURE__*/_react.default.createElement("text", {
    className: styles.label_text,
    transform: transform,
    x: ex + (cos >= 0 ? 1 : -1) * 10,
    y: ey,
    textAnchor: cos >= 0 ? 'start' : 'end'
  }, payload.name, " (", payload.value, ")"));
};
class PieChart extends _AuComponent.default {
  static propTypes = {
    data: T.arrayOf(T.object).isRequired,
    width: T.oneOfType([T.number, T.string]).isRequired,
    height: T.oneOfType([T.number, T.string]).isRequired,
    padding: T.number,
    colors: T.arrayOf(T.string),
    titleString: T.string,
    titleId: T.string,
    subTitleString: T.string,
    subTitleId: T.string,
    label: T.func,
    center: T.object
  };
  static defaultProps = {
    padding: 3,
    colors: ['#D0D0D0', '#E49816', '#A22330'],
    width: 360,
    height: 360,
    label: null,
    center: null
  };
  renderPie() {
    const {
      data,
      colors
    } = this.props;
    const emptyPie = data == undefined || data.length === 0;

    // Sort data in ascending order OR empty state (Recharts expects some data to render a chart)
    const sortedData = emptyPie ? [{
      name: '',
      value: 1
    }] : (0, _sort.default)(data).call(data, (a, b) => a.value - b.value);
    const cells = emptyPie ? /*#__PURE__*/_react.default.createElement(_recharts.Cell, {
      fill: "#E7E7E7"
    }) : (0, _map.default)(sortedData).call(sortedData, (_, index) => /*#__PURE__*/_react.default.createElement(_recharts.Cell, {
      key: `cell-${index}`,
      fill: colors[index % colors.length]
    }));
    return /*#__PURE__*/_react.default.createElement(_recharts.Pie, {
      data: sortedData,
      dataKey: "value",
      innerRadius: 100,
      startAngle: -270,
      label: emptyPie ? false : pieLabel,
      labelLine: false
    }, cells);
  }
  renderCenter() {
    const {
      center,
      width,
      height,
      titleString,
      subTitleString,
      titleId,
      subTitleId
    } = this.props;
    if (center) {
      return center;
    } else {
      return /*#__PURE__*/_react.default.createElement("g", null, /*#__PURE__*/_react.default.createElement("foreignObject", {
        x: 0,
        y: 0,
        width: width,
        height: height
      }, /*#__PURE__*/_react.default.createElement(_AutoIntl.default, {
        displayString: titleString,
        displayId: titleId,
        className: (0, _classnames.default)({
          [styles['centered_title']]: !subTitleString,
          [styles['title_with_subtitle']]: subTitleString
        }),
        tag: "div"
      }), /*#__PURE__*/_react.default.createElement(_AutoIntl.default, {
        displayString: subTitleString,
        displayId: subTitleId,
        className: styles.sub_title,
        tag: "div"
      })));
    }
  }
  render() {
    const {
      width,
      height,
      data
    } = this.props;
    return /*#__PURE__*/_react.default.createElement(_recharts.ResponsiveContainer, {
      width: width,
      height: height,
      className: styles.container
    }, /*#__PURE__*/_react.default.createElement(_recharts.PieChart, {
      width: width,
      height: height
    }, this.renderCenter(), this.renderPie(), data && data.length ? /*#__PURE__*/_react.default.createElement(_recharts.Tooltip, {
      content: /*#__PURE__*/_react.default.createElement(CustomTooltip, null)
    }) : null));
  }
}
exports.default = PieChart;